"use client";

import type { TPropsWithChildren } from "@/types";

type FilterSectionProps = TPropsWithChildren & {
	readonly [key: string]: any;
	readonly sectionTitle: string;
};

/**
 * Wrapper component with title to use for displaying different filter sections in the sidebar
 * @constructor
 */
export default function FilterSection(props: FilterSectionProps) {
	return (
		<section className={`bg-layoutContainer px-4 py-8 ${props.className}`}>
			<div
				role="heading"
				aria-level={2}
				className="hmc-subtitle-m mb-4 text-contentSilent"
				data-testid="filter-section-title"
			>
				{props.sectionTitle}
			</div>
			{props.children}
		</section>
	);
}
